import { getEmployeesService, updateEmployeeService, createSimpleEmployeeService, deleteEmployeeService, createEmployeeService, resetEmployeeService } from "@/services/employee.svc"

const defaultState = () => ({
    employees: [],
    headers: [
        {
            text: 'Last Name',
            value: 'LastName',
            sortable: true
        },
        {
            text: 'First Name',
            value: 'FirstName',
            sortable: true
        },
        {
            text: 'Middle',
            value: 'MiddleInitial',
            sortable: false
        },        
        {
            text: 'SSN',
            value: 'SSN',
            sortable: false
        },
        {
            text: 'Address',
            value: 'Address',
            sortable: false
        },
        {
            text: 'City',
            value: 'City',
            sortable: false
        },
        {
            text: 'State',
            value: 'State',
            sortable: false
        },
        {
            text: 'Zip',
            value: 'Zip',
            sortable: false
        },
        {
            text: 'Phone',
            value: 'Phone',
            sortable: false
        },
        {
            text: 'Emergency Contact',
            value: 'EmergencyContact',
            sortable: false
        },
        {
            text: 'Emergency Phone',
            value: 'EmergencyPhone',
            sortable: false
        },
        {
            text: 'DOB',
            value: 'DOB',
            sortable: true
        },
        {
            text: 'Hired',
            value: 'Hired',
            sortable: true
        },
        {
            text: 'Position',
            value: 'Position',
            sortable: true
        },
        {
            text: 'Base Wage',
            value: 'BaseWage',
            sortable: true
        },
        {
            text: 'Overtime Wage',
            value: 'OvertimeWage',
            sortable: true
        },
        {
            text: 'Active',
            value: 'Active',
            sortable: true
        },
        {
            text: 'Actions',
            value: 'actions',
            sortable: false
        }
    ]
})

export default {
    namespaced: true,
    state: defaultState(),

    actions: {
        async setEmployeesAction({ commit }, showAll = false) {
            const employees = await getEmployeesService(showAll)
            commit('SET_EMPLOYEES', employees)
        },

        async addEmployeeAction(_, payload) {
            return await createEmployeeService(payload)
        },

        async addSimpleEmployeeAction({ commit }, payload) {
            commit('ADD_EMPLOYEE', payload)
            return await createSimpleEmployeeService(payload)
        },

        async removeEmployeeAction(_, id) {
            return await deleteEmployeeService(id)
        },

        async resetEmployeeAction(_, id) {
            return await resetEmployeeService(id)
        },

        async editEmployeeAction(_, { id, data }) {
            return await updateEmployeeService(id, data)
        }
    },

    getters: {
        employees: (state) => state.employees,
        headers: (state) => state.headers,
        employeeDropdown: (state) => state.employees
            .filter(emp => emp.Active === 'Yes')
            .map(emp => ({ 
                ID: emp.ID, 
                FullName: emp.FirstName + ' ' + emp.LastName,
                BaseWage: emp.BaseWage
            }))
            .sort((a,b) => a.FullName.localeCompare(b.FullName)),
        getMaxID: () => {
            return async () => {
                const allEmployees = await getEmployeesService(true)
                return parseInt(allEmployees.sort((a,b) => parseInt(a.ID) - parseInt(b.ID)).pop().ID)
            }
        }
    },

    mutations: {
        SET_EMPLOYEES(state, payload) {
            state.employees = payload
        },

        ADD_EMPLOYEE(state, payload) {
            state.employees = [...state.employees, payload]
        }
    }
}